import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React from 'react';
import { Button } from '@piplapps/pipl-ui';
import { AppSelectors } from '../../Redux/modules/app/selectors';

function LoadingButton({ isLoading, ...props }) {
  return <Button isLoading={isLoading} loadingText={props.loadingText} {...props} />;
}

LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    isLoading: AppSelectors.loaderSelector(state),
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoadingButton);
